module.exports = __webpack_public_path__ + "img/x.9cfc22ba.jpg";